"use strict";

export default function setupViagemFilter() {
    const section = document.querySelector(".o-roteiros--filtro");
    if (!section) return;

    const grid = section.querySelector("[data-viagens-grid]");
    const loading = section.querySelector(".o-roteiros__loading");
    const form = section.querySelector(".o-filtro-roteiros__form");
    const btnContainer = section.querySelector(".button-container");
    const loadMoreBtn = btnContainer?.querySelector("[data-load-more]");
    if (!grid || !form) return;

    let currentPage = 1;

    function showLoading() {
        if (loading) loading.style.display = "block";
        grid.style.display = "none";
    }

    function hideLoading() {
        if (loading) loading.style.display = "none";
        grid.style.display = "";
    }

    function setLoadMoreVisible(visible) {
        if (btnContainer) btnContainer.style.display = visible ? "" : "none";
    }

    function setLoadMoreBusy(busy) {
        if (loadMoreBtn) {
            loadMoreBtn.style.opacity = busy ? "0.6" : "";
            loadMoreBtn.style.pointerEvents = busy ? "none" : "";
        }
    }

    // ===== dropdown open/close =====
    const filterItems = section.querySelectorAll(".c-select");

    document.addEventListener("click", (e) => {
        const item = e.target.closest(".c-select");
        if (!item || !section.contains(item)) return;

        const trigger =
            e.target.closest(".arrow") ||
            e.target.closest(".c-select__trigger") ||
            e.target.closest(".c-select__header") ||
            e.target.closest(".c-select__label") ||
            e.target.closest(".label");

        if (!trigger) return;

        const open = item.classList.contains("open");
        filterItems.forEach((i) => i.classList.remove("open"));
        if (!open) item.classList.add("open");
        e.stopPropagation();
    });

    document.addEventListener("click", () => {
        filterItems.forEach((i) => i.classList.remove("open"));
    });

    // ===== select option click =====
    document.addEventListener("click", (e) => {
        const option = e.target.closest(".option, .c-select__option");
        if (!option || !section.contains(option)) return;

        const parent = option.closest("[data-filter]");
        if (!parent) return;

        const value = option.dataset.value ?? "";
        parent.dataset.value = value;

        const label = parent.querySelector(".label, .c-select__label");
        if (label) label.innerText = option.innerText;

        parent.classList.add("selected");
        parent.classList.remove("open");
    });

    // ===== form submit =====
    form.addEventListener("submit", (e) => {
        e.preventDefault();
        updateFilters();
    });

    function getFilters() {
        return {
            destino:
                section.querySelector('[data-filter="destino"]')?.dataset
                    .value || "",
            duracao:
                section.querySelector('[data-filter="duracao"]')?.dataset
                    .value || "",
            pessoas:
                section.querySelector('[data-filter="pessoas"]')?.dataset
                    .value || "",
            preferencia:
                section.querySelector('[data-filter="preferencia"]')?.dataset
                    .value || "",
        };
    }

    function fetchViagens(page, append) {
        const f = getFilters();
        const qs = new URLSearchParams({ ...f, page }).toString();
        const ajaxUrl = window.ajaxurl || "/wp-admin/admin-ajax.php";

        if (append) {
            setLoadMoreBusy(true);
        } else {
            showLoading();
        }

        fetch(`${ajaxUrl}?action=filtrar_viagens_privativas&${qs}`, {
            method: "GET",
            credentials: "same-origin",
            headers: { "X-Requested-With": "XMLHttpRequest" },
        })
            .then((r) => r.json())
            .then(({ html, has_more }) => {
                if (append) {
                    grid.insertAdjacentHTML("beforeend", html);
                    setLoadMoreBusy(false);
                } else {
                    grid.innerHTML = html;
                    hideLoading();
                }
                currentPage = page;
                setLoadMoreVisible(has_more);
            })
            .catch(() => {
                if (append) {
                    setLoadMoreBusy(false);
                } else {
                    grid.innerHTML =
                        "<p>Erro ao carregar viagens. Tente novamente.</p>";
                    hideLoading();
                }
            });
    }

    function updateFilters() {
        currentPage = 1;
        fetchViagens(1, false);
    }

    if (loadMoreBtn) {
        loadMoreBtn.addEventListener("click", (e) => {
            e.preventDefault();
            fetchViagens(currentPage + 1, true);
        });
    }
}
